/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/AvataxSandboxAccountCard.js
 */

import React from 'react';
import cupIcon from '../../assets/CUPIcon.png';
import AvataxSandboxCard from './AvataxSandboxCard';

const CUPLink = 'https://sandbox.admin.avalara.com/cup/a/';
const CARD_NAME = 'Avatax Sandbox Account';

const AvataxSandboxAccountCard = ({ data, type }) => {
  return (
    <div className="Card">
      <div className="SectionTitle">
        <div>
          {CARD_NAME}
          <h1>{data.id}</h1>
        </div>
        <div className="logo-container">
          <a
            href={`${CUPLink}${data.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={cupIcon} alt="CUP Icon" className="CUPIcon" />
          </a>
        </div>
      </div>
      <div className="ResultsSection">
        <div className="DeliveryResultsSection">
          <AvataxSandboxCard
            deliveryInfo={{
              ...data,
              displayName: data.deliverySystem,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AvataxSandboxAccountCard;
